import type { CSSProperties, ReactNode } from 'react';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconClock } from '@sorare/core/src/atoms/icons/system/iconClock.ts';
import { css } from '@sorare/css';

const anchor = css`
  position: relative;
  flex: none;
  line-height: 0;
`;

const badge = css`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0 0 calc(var(--half-unit) / 2) var(--status-ring-color);
`;

const dot = css`
  width: var(--unit);
  height: var(--unit);
  background: var(--c-score-high);
`;

const upcoming = css`
  width: var(--double-unit);
  height: var(--double-unit);
  background: var(--c-nd-300);
  color: var(--c-nd-800);
`;

type Props = {
  available: boolean;
  ringColor?: string;
  children: ReactNode;
};

export const WithCompetitionStatusDot = ({
  available,
  ringColor = 'var(--c-black)',
  children,
}: Props) => (
  <span className={anchor}>
    {children}
    <span
      className={[badge, available ? dot : upcoming].join(' ')}
      style={{ '--status-ring-color': ringColor } as CSSProperties}
    >
      {!available && <FontAwesomeIcon icon={iconClock} size="2xs" />}
    </span>
  </span>
);
